import React from 'react';
import styled from 'styled-components';
import { ThemeColors } from '../../themes/online';

// ############################ Styles ###########################
// tslint:disable:variable-name

// tslint:disable-next-line:variable-name
const SInputLabel = styled.label(
  ({ theme, color }) => `
  color: red;
  font-weight: ${theme.font.weight.normal};
  font-size: ${theme.font.size.small};
  margin-bottom: ${theme.spacing.small}px;
  color: ${color ? theme.colors[color] : theme.colors.grayBlueish};
  @media only screen and (min-width: 500px) {
    font-size: ${theme.font.size.smallMedium2};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IInputLabelProps {
  dataAt: string;
  className?: string;
  inputValue?: string;
  inputId?: string;
  color?: ThemeColors;
}

// tslint:disable-next-line:variable-name
const InputLabel: React.FC<IInputLabelProps> = (props) => (
  <SInputLabel color={props.color} htmlFor={props.inputId || ''} tabIndex={0} data-at={props.dataAt} className={`inputLabel ${props.className}`}>
    {props.children}
  </SInputLabel>
);

export default InputLabel;
